import React, { Dispatch, SetStateAction } from 'react';

import { Modal, ModalContent, ModalHeader, ModalCloseButton } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

import { ContentViewingPrefsForm } from '../form/Settings/ContentViewingPrefsForm';
import { Modals } from './types';

type Filters = Record<string, { rating: number; name: string }>;

interface Props {
  active?: boolean;
  activeSet: Dispatch<SetStateAction<Modals | null>>;
  contentViewingPrefs: {
    selected: number;
    filters: Filters;
    customFilters: Filters;
  };
  token: string;
}

export function ContentFilterModal({ active, activeSet, token, contentViewingPrefs }: Props) {
  return (
    <Modal isOpen={!!active} onClose={() => activeSet(null)}>
      <ModalContent>
        <ModalHeader>{translate('Mature content filter')}</ModalHeader>
        <ModalCloseButton />
        <ContentViewingPrefsForm
          {...contentViewingPrefs}
          token={token}
          onClose={() => activeSet(null)}
        />
      </ModalContent>
    </Modal>
  );
}
